import { IOrderLogRepository } from "./interfaces/IOrderRepository"

const ClearOrderLogUseCase = async (repository: IOrderLogRepository ) => {
    await repository.clearOrderLogs()
}
export default ClearOrderLogUseCase